var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',{class:`drawer-container ${_vm.drawer}`},_vm._l((_vm.items),function(comp,id){return _c(comp.component,_vm._b({key:id,tag:"component"},'component',comp.attrs,false))}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }